<template>
    <div>
        <v-toolbar class="glass rounded-lg" flat>
            <v-toolbar-title>
                Why Us
            </v-toolbar-title>
            <v-spacer/>
            <v-dialog v-model="dialog" max-width="600">
                <template v-slot:activator="{ on, attrs}">
                    <v-btn color="primary" v-on="on" v-bind="attrs">
                        Add New
                    </v-btn>
                </template>

                <v-form @submit.prevent="addEditService">
                    <v-card>
                        <v-card-title class="mb-3">
                            {{ formTitle }}
                        </v-card-title>

                        <v-card-text>
                            <v-text-field
                                outlined
                                dense
                                v-model="form.title"
                                label="Title"
                            />
                            <v-textarea
                                rows="3"
                                outlined
                                dense
                                v-model="form.detail"
                                label="Detail"
                            />
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer/>
                            <v-btn @click="close" depressed outlined color="warning" class="mx-1">
                                Cancel
                            </v-btn>

                            <v-btn type="submit" depressed   color="success" class="mx-1">
                                Submit
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-toolbar>

        <v-card>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="$page.props.whyus"
                >


                    <template v-slot:item.actions="{ item }">
                        <div class="d-flex">
                            <v-btn class="mx-1" small color="success" @click="editService(item)">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn class="mx-1" small color="error" @click="deleteService(item)">
                                <v-icon>mdi-trash-can</v-icon>
                            </v-btn>
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import AdminLayout from "../AdminLayout";
export default {
    name: "Index",
    layout:AdminLayout,
    data(){
        return {
            dialog:false,
            form:this.$inertia.form({
                id:null,
                title:null,
                detail:null,
            }),
            headers:[
                {text:'Title', value:'title'},
                {text:'Detail', value:'detail'},
                {text:'Actions', value:'actions',sortable:false},
            ]
        }
    },

    computed:{

        formTitle(){

            if(this.form.id){
                return 'Edit '+this.form.title+ ' Why Us'
            }else{
                return 'New Why Us'
            }
        }
    },

    methods:{
        addEditService(){
            this.form.post(route('admin.why-us.store'),{
                onSuccess:()=>{
                    this.close()
                }
            })
        },

        close(){
            this.form.reset()
            this.dialog = false
        },

        editService(service){
            this.form.id      = service.id
            this.form.title   = service.title
            this.form.detail = service.detail
            this.dialog = true
        },

        deleteService(service){
            Swal.fire({
                title: 'Are you sure?',
                text: ""+service.title+ " will be deleted!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {

                    this.$inertia.delete(route('admin.why-us.destroy',service.id),{
                        resetOnSuccess: false,
                        onSuccess: ()=>{
                            Toast.fire({
                                icon: 'success',
                                title: 'Why Us Deleted'
                            })
                        }
                    })
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
